import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import {SoopButtonCommon, SoopChip} from '@soop-ui/soop-ui';
import {HELP_LOG} from '@/constants/help';
import {sendHelpClickLog} from '@/utils/help/log';
import BotHead from '../BotHead';
import styles from './BotMessage.module.scss';
import {BotMessageType} from '../type';

interface BotMessageProps extends BotMessageType {
  handleSend: (text: string, callback?: () => void) => void;
}

const BotMessage = ({
  text,
  links,
  keywords,
  date,
  handleSend,
}: BotMessageProps) => {
  const sendClickLog = (
    actionType:
      | typeof HELP_LOG.ACTION_TYPE.TO_BUTTON
      | typeof HELP_LOG.ACTION_TYPE.TO_KEYWORD,
    text: string,
  ) => {
    sendHelpClickLog(HELP_LOG.CODE_TYPE.CHATBOT, {
      buttonType: HELP_LOG.BUTTON_TYPE.CHATBOT_CONTENTS,
      actionType,
      text,
    });
  };

  const handleLinkClick = (title: string, url: string) => {
    window.open(url, '_blank', 'noopener noreferrer');
    sendClickLog(HELP_LOG.ACTION_TYPE.TO_BUTTON, title);
  };

  const handleKeywordClick = (keyword: string) => {
    handleSend(keyword, () =>
      sendClickLog(HELP_LOG.ACTION_TYPE.TO_KEYWORD, keyword),
    );
  };

  return (
    <>
      <BotHead />
      <div className={styles.SystemMessageArea}>
        <div className={styles.MessageArea}>
          <div className={styles.Message}>
            <Markdown
              remarkPlugins={[remarkGfm, remarkBreaks]}
              components={{
                a: ({node, ...props}) => (
                  <a {...props} target='_blank' rel='noopener noreferrer' />
                ),
              }}>
              {text}
            </Markdown>
          </div>
          {links.length > 0 && (
            <div className={styles.ButtonListWrapper}>
              {links.map(({title, url}) => (
                <SoopButtonCommon
                  key={url}
                  variant='defaultPrimary'
                  size={36}
                  onClick={() => handleLinkClick(title, url)}>
                  {title}
                </SoopButtonCommon>
              ))}
            </div>
          )}
        </div>
        {keywords.length > 0 && (
          <div className={styles.KeywordListWrapper}>
            {keywords.map((keyword) => (
              <SoopChip
                key={keyword}
                color='secondary'
                type='button'
                onClick={() => handleKeywordClick(keyword)}>
                {keyword}
              </SoopChip>
            ))}
          </div>
        )}
        <span className={styles.date}>{date}</span>
      </div>
    </>
  );
};

export default BotMessage;
